import logger from "./logger";

const MAX_REPORTS_PER_SESSION = 50;
const ERROR_LOG_PATH = "/error-log";

let reported = 0;
let installed = false;

function report(message, context) {
  if (reported >= MAX_REPORTS_PER_SESSION) return;
  reported += 1;
  logger.error(message, context);
}

function describeRequestFailure(error) {
  const config = error.config || {};
  const data = error.response && error.response.data;
  const serverMessage = data && typeof data === "object" ? data.message : undefined;
  return {
    method: config.method,
    url: typeof config.url === "string" ? config.url.split("?")[0] : undefined,
    status: error.response ? error.response.status : undefined,
    code: error.code,
    serverMessage: typeof serverMessage === "string" ? serverMessage.slice(0, 300) : undefined,
  };
}

export function installGlobalErrorLogging(axiosInstance) {
  if (installed) return;
  installed = true;

  window.addEventListener("error", (event) => {
    // Browsers raise this benign warning on every layout pass that resizes an observed element.
    if (typeof event.message === "string" && event.message.includes("ResizeObserver loop")) return;
    report("Uncaught error", {
      message: event.message,
      source: event.filename,
      line: event.lineno,
      column: event.colno,
      stack: event.error && event.error.stack,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    report("Unhandled promise rejection", {
      message: reason && reason.message ? reason.message : String(reason),
      stack: reason && reason.stack,
    });
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const url = error && error.config && error.config.url;
        const isLoggerCall = typeof url === "string" && url.includes(ERROR_LOG_PATH);
        if (!isLoggerCall && navigator.onLine !== false) {
          report("API request failed", describeRequestFailure(error));
        }
      } catch (e) {
        // Logging must never change how a failed request propagates.
      }
      return Promise.reject(error);
    }
  );

  if (process.env.NODE_ENV === "production") {
    const originalConsoleError = console.error;
    console.error = (...args) => {
      originalConsoleError.apply(console, args);
      try {
        const err = args.find((a) => a instanceof Error);
        report("console.error", {
          message: args.map((a) => (a instanceof Error ? a.message : String(a))).join(" ").slice(0, 500),
          stack: err && err.stack,
        });
      } catch (e) {
        // Same guarantee as above.
      }
    };
  }
}

export function resetGlobalErrorLoggingForTests() {
  reported = 0;
  installed = false;
}
